export default function () {
  // Create the measurement node
  const scrollDiv = document.createElement('div');
  scrollDiv.classList.add('scrollbar-measure');
  document.body.appendChild(scrollDiv);
  // Get the scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  // Delete the DIV
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}



// WEBPACK FOOTER //
// ./scripts/utils/scroll-bar-width.js